<template>
  <div class="d-flex justify-content-end pt-2">
    <v-btn icon @click="$refs.inputUpload.click()" :disabled="disabled">
      <v-icon color="#3F51B5">mdi-paperclip</v-icon>
    </v-btn>
    <input 
      v-show="false"
      accept="image/jpeg,image/png"
      ref="inputUpload" 
      type="file" 
      @change="saveImage" 
    />
  </div>
</template>

<script>
import { fileSizeToMB, validFileSize10MB } from '@/utils/fileSizeToMB';
import { optimizePhotos, uploadImage } from '@/utils/upload-image';
import { v4 as uuidv4 } from 'uuid';
import { waitResizedImage } from '@/utils/wait-resized-image';
import * as firebase from 'firebase/app';

export default {
  name: "FeedbackMediaUploader",
  props: {
    filePath: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgLoading: false
    }
  },
  methods: {
    async saveImage(e) {
      if (!e || !e.target.files.length || !e.target.files[0]) return;

      const fileInput = this.$refs.inputUpload;
      const path = `${this.filePath}/${uuidv4()}`;
      const file = await optimizePhotos(e.target.files[0], '');
      const fileSizeInMegabytes = fileSizeToMB(file?.size);

      const allowedImageTypes = ['image/jpeg', 'image/png'];
      const isImage = allowedImageTypes.includes(file.type);

      if (!isImage) {
        fileInput.value = null;
        this.$toast.open({
          message: 'Only JPEG and PNG images are allowed',
          type: 'error'
        });
        return;
      }

      if (!validFileSize10MB(fileSizeInMegabytes)) {
        fileInput.value = null;
        this.$toast.open({
          message: 'File size must be less than 10MB',
          type: 'error'
        });
        return;
      }

      uploadImage({
        path,
        file,
        onStart: () => {
          this.imgLoading = true;
          this.$emit('onFileStartUpload');
        },
        onComplete: async storage => {
          try {
            const uploadedUrl = await storage.snapshot.ref.getDownloadURL();
            const resizedImageRef = await firebase.storage().ref().child(`${path}_200x200`);
            const resizedImageUrl = await waitResizedImage(10, resizedImageRef);
            
            const uploadedFile = {
              type: 'image',
              url: uploadedUrl,
              thumbnailUrl: resizedImageUrl,
              fileName: file.name || 'image'
            };
            
            this.$emit('onFileUploaded', uploadedFile);
          } catch (e) {
            console.error(e);
            this.$emit('onFileUploaded', null);
            this.$toast.open({
              message: 'Failed to upload image',
              type: 'error'
            });
          }
          fileInput.value = null;
          this.imgLoading = false;
        }
      });
    }
  }
}
</script>

<style scoped>
</style>
